import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import { ChevronLeft } from 'lucide-react';
//import './App.css';

export default function TinyMCE({editorText, header, onSave}) {
  const editorRef = useRef(null);
  const navigate = useNavigate();
  
  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className='flex justify-start mt-2 mb-3'>
        <button 
          onClick={goBack}
          className="bg-[#1a4565] text-white p-1 h-8 w-8 rounded-sm transition-opacity hover:opacity-80"
          aria-label="Go Back"
        >
          <ChevronLeft size={20} />
        </button>
        <h1 className='bigger-font ml-4'><strong>{header}</strong></h1>
      </div>
      <Editor
        apiKey='1we2mi01qfbhm8gybr6202do4nu67nqcfg8cd5lj8ro7poeu'
        onInit={ (_evt, editor) => editorRef.current = editor }
        initialValue={editorText}
        init={{
          height: 500,
          menubar: false,
          statusbar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'save', 'table', 'code', 'help', 'wordcount'
          ],
          toolbar: 'save undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          save_onsavecallback: function() {
            const content = editorRef.current.getContent();
            console.log('Saving content:', content);
            onSave(content);          },
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
      />
    </>
  );
}